import { render, staticRenderFns } from "./TamanhoVals.vue?vue&type=template&id=03980bde&scoped=true&"
import script from "./TamanhoVals.vue?vue&type=script&lang=js&"
export * from "./TamanhoVals.vue?vue&type=script&lang=js&"
import style0 from "./TamanhoVals.vue?vue&type=style&index=0&id=03980bde&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03980bde",
  null
  
)

export default component.exports